module.exports = __webpack_public_path__ + "img/mundial.4ad0837b.png";